import { Card, Loader } from '@lifebit-ai/lds'
import React from 'react'

import type { RequestActivitySource } from 'services/request-activity/types'
import { useRequestActivity } from 'services/request-activity/useRequestActivity'
import { CardBody, CardHeading } from 'ui/card/card.styles'

import { REQUEST_ACTIVITY_TEST_ID, REQUEST_ACTIVITY_TITLE, RequestActivity } from './RequestActivity'
import * as styles from './RequestActivity.styles'

export const REQUEST_ACTIVITY_LOADER_TEST_ID = 'request-activity-loader'
export const REQUEST_ACTIVITY_ERROR_TEST_ID = 'request-activity-error'

export interface RequestActivityCardProps {
  source: RequestActivitySource
}

export const RequestActivityCard = ({ source }: RequestActivityCardProps): JSX.Element => {
  const { events, isLoading, isError } = useRequestActivity(source)

  if (isLoading) {
    return (
      <Card data-testid={REQUEST_ACTIVITY_TEST_ID}>
        <CardBody>
          <styles.Header>
            <CardHeading>{REQUEST_ACTIVITY_TITLE}</CardHeading>
          </styles.Header>
          <div data-testid={REQUEST_ACTIVITY_LOADER_TEST_ID}>
            <Loader />
          </div>
        </CardBody>
      </Card>
    )
  }

  if (isError) {
    return (
      <Card data-testid={REQUEST_ACTIVITY_TEST_ID}>
        <CardBody>
          <styles.Header>
            <CardHeading>{REQUEST_ACTIVITY_TITLE}</CardHeading>
          </styles.Header>
          <styles.EmptyMessage data-testid={REQUEST_ACTIVITY_ERROR_TEST_ID}>
            Couldn't load review activity.
          </styles.EmptyMessage>
        </CardBody>
      </Card>
    )
  }

  return <RequestActivity events={events} />
}

export default RequestActivityCard
